import styled from 'styled-components';

// Material-UI
import Popover from '@material-ui/core/Popover';

// *************************************
// STYLED COMPONENTS                           
// *************************************

// Popover
export const StyledPopover = styled(Popover)`
  .MuiPopover-paper {
    left: auto !important;
    right: 16px !important;
    top: 60px !important;
    overflow-y: hidden;
    overflow-x: hidden;
    border-radius: 6px;
    border: 1px solid ${(props) => props.theme.colors.greyLight};
    box-shadow: ${(props) => props.theme.shadows.depth4};
  }
`;